module.exports = new __parcel__URL__("jpd-user-limit.d8e72df9.png").toString();